import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import LogsList from '../../views/Logs/LogsList.js'

const ProfileRout = () => {
  return (
    <div>
      <Routes>
        <Route path="/Logs" element={<LogsList />} />

        <Route path="/" element={<Navigate to="/logs" replace />} />
      </Routes>
    </div>
  )
}

export default ProfileRout
